import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { EntityTypeFilterValue } from "../../../../legacy/types/companyFilter";
import { INSTALL_COUNT_QUERY } from "../queries/installCountQuery";
import { COMPANY_SEARCH_CLIENT } from "../../../../utils/consts";

export const useInstallCountQuery = (
  vendorId: number,
  localizeInstalls: boolean,
  entityTypeFilterValue: EntityTypeFilterValue
) => {
  const { data, loading } = useQuery(INSTALL_COUNT_QUERY, {
    variables: {
      vendorId,
      localizeInstalls,
      ...entityTypeFilterValue,
    },
    skip: vendorId === 0,
    context: { clientName: COMPANY_SEARCH_CLIENT },
  });

  const count = useMemo(
    () => data?.productCatalogInstallsCount.count || 0,
    [data]
  );

  return { count, loading };
};
